var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayout',{staticClass:"pre-test-wrapper quidle-wrapper",class:{lessHeight:_vm.lessHeight},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('router-view')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }